import React from 'react';
import { Button, ButtonHierarchies, DropdownMenu, Tooltip } from '@clockout-dev/design-elements';
import { ChevronDownIcon, EyeIcon } from '@heroicons/react/24/outline';
import { USER_HEADER_COPY } from '../user.constants';
import { SSO_DISABLED_TOOLTIP } from '../../../../constants/sso.constants';
import styles from './styles/user-header.module.scss';

/**
 * Trailing header actions: More actions ▾ and View as user (primary).
 *
 * View as user keeps the SSO contract of the previous header untouched: it
 * renders for every admin, *disabled* (never hidden) without `admin:sso:open`,
 * with the tooltip reachable by hover and keyboard focus on the wrapper slot.
 *
 * @param {Object} props
 * @param {Array<Object>} [props.moreActions] DropdownMenu items, built by
 *   `UserHeaderController.toMoreActionMenuItems`.
 * @param {boolean} [props.canOpenSso]
 * @param {() => void} props.onOpenSso
 */
function UserHeaderActions({ moreActions = [], canOpenSso = false, onOpenSso }) {
    return (
        <div className={styles.actions}>
            <DropdownMenu items={moreActions}>
                <Button hierarchy={ButtonHierarchies.SECONDARY} trailingIcon={<ChevronDownIcon />}>
                    {USER_HEADER_COPY.MORE_ACTIONS}
                </Button>
            </DropdownMenu>
            {/* A natively-disabled <button> fires no mouse events and leaves
                the tab order, so the slot carries the tooltip and becomes a
                tab stop only when there is something to explain. */}
            <Tooltip title={canOpenSso ? '' : SSO_DISABLED_TOOLTIP} trigger={['hover', 'focus']}>
                <span className={styles.actionSlot} data-testid="open-sso-slot" tabIndex={canOpenSso ? undefined : 0}>
                    <Button icon={<EyeIcon />} onClick={onOpenSso} disabled={!canOpenSso}>
                        {USER_HEADER_COPY.VIEW_AS_USER}
                    </Button>
                </span>
            </Tooltip>
        </div>
    );
}

export default UserHeaderActions;
